import { ReactComponent as LogoSVG } from 'assets/svg/logo.svg';
import LanguageSelector from 'components/common/selectors/LanguageSelector';

export default function SiteHeader({ enableLanguageSelector = true }) {
  const showLogo = !window.location.href.includes('my-business-tools');

  return (
    <nav className="site-nav stacked">
      <ul>
        {showLogo && (
          <li>
            <LogoSVG />
          </li>
        )}
        {enableLanguageSelector && <LanguageSelector />}
      </ul>
    </nav>
  );
}
